<template>
    <div class="order-voucher row">
        <div v-if="basket" class="col">
            <h4>1. Do you have a discount code?</h4>

            <div class="form-row">
                <div class="col-8">
                    <input v-model="voucher" type="text" class="form-control mr-2 w-100" :disabled="loading"
                           placeholder="Enter discount code">
                </div>
                <div class="col-4">
                    <button v-if="basket.voucher_code" @click="removeVoucher()" class="btn btn-tertiary">
                        Remove
                    </button>
                    <button v-else @click="applyVoucher()" class="btn btn-secondary" :disabled="loading">
                        Apply
                    </button>
                </div>
            </div>
            <div v-if="localOutOfStockBasketItems.length > 0" class="alert compact alert-danger mt-4">
                <p>This discount code is only valid for eligible in stock items. The following items are currently not in stock, so would be charged at full price:</p>
                <ul>
                    <li v-for="item in localOutOfStockBasketItems" :key="item.id">
                        {{ item.name }}
                    </li>
                </ul>
                <div>
                    <button class="btn btn-tertiary" @click="removeOutOfStockItems()">Remove out of stock items</button>
                </div>
            </div>
            <div v-if="errors.length > 0" class="alert compact alert-danger mt-4">
                <span v-for="error in errors">{{ error }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "../../../app";

export default {
    data() {
        return {
            loading: false,
            voucher: null,
            errors: [],
            localOutOfStockBasketItems: [...this.outOfStockBasketItems]
        };
    },

    props: {
        basket: {
            type: Object,
        },
        outOfStockBasketItems: {
            type: Array,
        },
    },

    watch: {
        basket: function () {
            if (typeof this.basket !== "undefined" && this.basket.voucher_code) {
                this.voucher = this.basket.voucher_code;
            } else {
                this.voucher = null;
            }
        }
    },

    mounted() {
        EventBus.$on('removeVoucher', () => {
            this.removeVoucher();
        });
    },

    methods: {
        applyVoucher() {
            //this.loading = true;
            this.errors = [];
            //document.querySelector("button.payment").disabled = true;

            axios.post('/api/v1/checkout/voucher/add', {
                'voucher_code': this.voucher,
            })
                .then(res => {
                    if (res.data && res.data.success) {
                        // Get current delivery total before basket updates.
                        let deliveryTotal = document.getElementById('delivery-total').innerHTML;
                        this.$root.basket = res.data.basket;
                        this.localOutOfStockBasketItems = res.data.outOfStockBasketItems;

                        if (res.data.free_shipping_voucher) {
                            if(deliveryTotal) {
                                document.getElementById('discount-total').innerHTML = '-' + deliveryTotal;
                            }

                            EventBus.$emit('freeShippingEnabled');
                        }
                    }
                })
                .catch(err => {
                    if (err.response.status === 422) {
                        for (const x in err.response.data.errors) {
                            for (const y in err.response.data.errors[x]) {
                                this.errors.push(err.response.data.errors[x][y]);
                            }
                        }
                    } else {
                        this.errors.push('Sorry, an unexpected error occurred. Please try again later.');
                    }
                })
                .finally(() => {
                    this.loading = false;
                    document.querySelector("button#continueButton").disabled = false;
                });
        },

        removeVoucher() {
            this.loading = true;
            this.errors = [];
            document.querySelector("button#continueButton").disabled = true;

            axios.post('/api/v1/checkout/voucher/remove')
                .then(res => {
                    if (res.data && res.data.success) {
                        this.$root.basket = res.data.basket;
                        this.localOutOfStockBasketItems = [];
                    }
                })
                .catch(err => {
                    if (err.response.status === 422) {
                        for (const x in err.response.data.errors) {
                            for (const y in err.response.data.errors[x]) {
                                this.errors.push(err.response.data.errors[x][y]);
                            }
                        }
                    } else {
                        this.errors.push('Sorry, an unexpected error occurred. Please try again later.');
                    }
                })
                .finally(() => {
                    this.loading = false;
                    document.querySelector("button#continueButton").disabled = false;
                });
        },

        removeOutOfStockItems() {
            this.loading = true;
            this.errors = [];
            document.querySelector("button#continueButton").disabled = true;

            const postData = this.localOutOfStockBasketItems.map(item => ({
                basket_item_id: item.id,
                quantity: item.quantity,
                addon_item_comment: item.addon_item_comment
            }));

            axios.post('/api/v1/basket/remove', postData)
                .then(res => {
                    if (res.data && res.data.success) {
                        this.$root.basket = res.data.basket;
                        this.localOutOfStockBasketItems = [];
                    }
                })
                .catch(err => {
                    if (err.response.status === 422) {
                        for (const x in err.response.data.errors) {
                            for (const y in err.response.data.errors[x]) {
                                this.errors.push(err.response.data.errors[x][y]);
                            }
                        }
                    } else {
                        this.errors.push('Sorry, an unexpected error occurred. Please try again later.');
                    }
                })
                .finally(() => {
                    this.loading = false;
                    document.querySelector("button#continueButton").disabled = false;
                });
        }
    },
};
</script>
